export const sessionResultsFilter = {
    namespaced: true,

    state: {
        selectedAthletes: [],
        selectedTelemetryAthletes: [],
        selectedSquads: [],
        selectedCrews: [],
        selectedPieces: []
    },

    getters: {
        selectedAthletes(state) {
            const athletes = [];
            state.selectedSquads.forEach(squad => {
                athletes.push(...squad.squad_users);
            });

            state.selectedCrews.forEach(squad => {
                athletes.push(...squad.crew_users);
            });
            athletes.push(...state.selectedAthletes);
            return [...new Set(athletes)];
        },

        selectedTelemetryAthletes(state) {
            return state.selectedTelemetryAthletes;
        },

        selectedCrews(state) {
            return state.selectedCrews;
        },

        selectedPieces(state) {
            return state.selectedPieces;
        }
    },

    mutations: {
        clearFilter(state) {
            state.selectedAthletes = [];
            state.selectedTelemetryAthletes = [];
            state.selectedSquads = [];
            state.selectedCrews = [];
            state.selectedPieces = [];
        },

        setSelectedAthletes(state, data) {
            state.selectedAthletes = data;
        },

        setSelectedTelemetryAthletes(state, data) {
            state.selectedTelemetryAthletes = data;
        },

        setSelectedSquads(state, data) {
            state.selectedSquads = data;
        },

        deselectAthlete(state, athleteId) {
            const athletesFromSelectedCrews = [];
            state.selectedCrews.forEach(crew => athletesFromSelectedCrews.push(...crew.crew_users));
            const isSelectedInCrew = [...new Set(athletesFromSelectedCrews)].includes(athleteId);
            const index = state.selectedAthletes.indexOf(athleteId);
            !isSelectedInCrew && index !== -1 && state.selectedAthletes.splice(index, 1);
        },

        setSelectedCrews(state, data) {
            state.selectedCrews = data;
        },

        setSelectedPieces(state, data) {
            state.selectedPieces = data;
        }
    }
};

export default sessionResultsFilter;
